import { defineMessage, useIntl } from 'react-intl';

import { DocsList, IDocsListItem } from '@src-common/view/components/DocsList';

import s from './styles.module.css';

interface Props<T extends IDocsListItem> {
  docs: T[];
  onUploadDoc: (event: React.SyntheticEvent, document: T) => void;
}

const docTitle = defineMessage({
  defaultMessage: 'Documents',
  id: 'wVBktP',
  description: 'Docs list title',
});

export const ProfileDocsList = <T extends IDocsListItem>({ docs, onUploadDoc }: Props<T>) => {
  const intl = useIntl();

  return (
    <DocsList<T>
      title={intl.formatMessage(docTitle)}
      className={s.docs}
      onChange={onUploadDoc}
      docs={docs}
    />
  );
};
